import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { toast } from "react-toastify";

import NetaqInput from "../../../components/NetaqInput";
import { useTranslate } from "../../../components/TranslationText";
import EahsForm from "../../../components/EahsForm";
import FollowUpData from "../../../components/FollowUpData";
import SearchBox from "../../../components/SearchBox";
import NewActionButton from "../../../components/ActionButtons/NewActionButton";
import CustomPopUp from "../../../components/CustomPopUp";
import { formatDateTimeToString } from "../../../helper/formatDateTimeToString";
import {
    eformCheckBox,
    eformInput,
} from "../../../common/cssclasses";

import {
    FetchAddFollowUpthunk,
    FetchConfirmImportDatethunk,
    FetchConfirmReceivedHorseDatethunk,
    FetchDeleteOwnerShipTransferServicesRequeststhunk,
    FetchGetAllServicesRequeststhunk,
    FetchGetFollowUpDatathunk,
} from "../../../Redux/ServicesRequests/ServicesRequestsAction";
import { resetToasterMessageServicesRequests } from "../../../Redux/ServicesRequests/ServicesRequestsSlice";

export default function AllServicesRequestsPage() {
    const { translate } = useTranslate();
    const dispatch = useDispatch();

    const {
        getAllServicesRequestsData,
        servicesRequestsLoading,
        toasterMessageServicesRequests,
        followUpData,
        paginationInfo
    } = useSelector((state) => state.servicesRequestsSlice);

    const { currentLanguage } = useSelector((state) => state.studBookSlice);

    const pageSize = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const [searchServices, setSearchServices] = useState("");
    const [openPopup, setOpenPopup] = useState(false);
    const [serviceRequestId, setServiceRequestId] = useState("");
    const [chat, setChat] = useState("");
    const [errorChat, setErrorChat] = useState(false);
    const [importDate, setImportDate] = useState(null);
    const [receivedHorseDate, setReceivedHorseDate] = useState(null);
    const [exportDateModal, setExportDateModal] = useState("");
    const [willNotReturn, setWillNotReturn] = useState(false);
    const [returnReason, setReturnReason] = useState("");

    const [errorConfirmImportDate, setErrorConfirmImportDate] = useState(false);
    const [errorConfirmReceivedHorseDate, setErrorConfirmReceivedHorseDate] = useState(false);
    const [errorReason, setErrorReason] = useState(false);
    const [errorExportDate, setErrorExportDate] = useState(false);

    const [openChatPopup, setOpenChatPopup] = useState(false);
    const [openConfirmImportDatePopup, setOpenConfirmImportDatePopup] = useState(false);
    const [openConfirmReceivedHorseDatePopup, setOpenConfirmReceivedHorseDatePopup] = useState(false);
    const [referenceNumber, setReferenceNumber] = useState("");
    const [serviceDefinitionName, setServiceDefinitionName] = useState("");
    const [importDateD, setImportDateD] = useState("");
    const [receivedHorseDateD, setReceivedHorseDateD] = useState("");
    const [chatAction, setChatAction] = useState(false);

    const windowHeight = window.innerHeight;

    // Server-side pagination: total pages come from the API response
    const totalPages = paginationInfo ? Math.ceil(paginationInfo.totalCount / pageSize) : 0;

    const fetchData = (page = 1, keyword = searchServices) => {
        const skip = (page - 1) * pageSize;
        const cleanKeyword = (keyword || '').trim();
        const params = {
            language: currentLanguage,
            userId: localStorage.getItem("currentSubAccountId"),
            skip,
            take: pageSize,
            keyword: cleanKeyword,
        };
        dispatch(FetchGetAllServicesRequeststhunk(params));
    };

    useEffect(() => {
        fetchData(1);
        setCurrentPage(1);
    }, [currentLanguage]);

    useEffect(() => {
        if (
            toasterMessageServicesRequests != null &&
            (toasterMessageServicesRequests === "save" || toasterMessageServicesRequests === "saveFollowUp")
        ) {
            dispatch(resetToasterMessageServicesRequests());

            if (toasterMessageServicesRequests === "save") {
                toast.success(
                    translate("web.dataSavedSuccessfully", "Data Saved Successfully")
                );
                fetchData(currentPage);
            } else if (toasterMessageServicesRequests === "saveFollowUp") {
                toast.success(
                    translate("web.sendFollowUp", "Message sent successfully")
                );
            }
        }
    }, [toasterMessageServicesRequests]);

    const handleSearchChange = (e) => {
        const val = e?.target?.value ?? "";
        setSearchServices(val);
        if (!val.trim()) {
            fetchData(1, "");
            setCurrentPage(1);
        }
    };

    const handleSearchSubmit = () => {
        const keyword = (searchServices || "").trim();
        fetchData(1, keyword);
        setCurrentPage(1);
    };

    const handlePageChange = (newPage) => {
        if (newPage < 1 || newPage > totalPages) return;
        setCurrentPage(newPage);
        fetchData(newPage, searchServices || "");
        window.scrollTo(0, 0);
    };

    // Server returns the current page's data directly — no client-side slicing needed
    const currentData = getAllServicesRequestsData;

    const closeModal = () => {
        setOpenPopup(false);
        setServiceRequestId("");
    };

    const closeChatModal = () => {
        setOpenChatPopup(false);
        setChat("");
        setErrorChat(false);
    };

    const closeConfirmImportDateModal = () => {
        setOpenConfirmImportDatePopup(false);
        setImportDate(null);
        setErrorConfirmImportDate(false);
    };

    const closeConfirmReceivedHorseDateModal = () => {
        setOpenConfirmReceivedHorseDatePopup(false);
        setExportDateModal("");
        setReceivedHorseDate(null);
        setReturnReason("");
        setErrorExportDate(false);
        setErrorConfirmReceivedHorseDate(false);
        setErrorReason(false);
    };

    const handelDeleteServiceRequest = (id) => {
        dispatch(FetchDeleteOwnerShipTransferServicesRequeststhunk(id));
    };

    const handelConfirmImportDate = (id) => {
        if (importDate != null) {
            let params = {
                id: id,
                importDate: dayjs(importDate).format("DD/MM/YYYY"),
            };
            setImportDate(null);
            setErrorConfirmImportDate(false);
            setOpenConfirmImportDatePopup(false);
            dispatch(FetchConfirmImportDatethunk(params));
        } else {
            setErrorConfirmImportDate(true);
            return false;
        }
    };

    const handelConfirmReceivedHorseDate = (id) => {
        setErrorExportDate(false);
        setErrorConfirmReceivedHorseDate(false);
        setErrorReason(false);

        if (!exportDateModal) {
            setErrorExportDate(true);
            return false;
        }

        if (!willNotReturn && !receivedHorseDate) {
            setErrorConfirmReceivedHorseDate(true);
            return false;
        }

        if (willNotReturn && !returnReason.trim()) {
            setErrorReason(true);
            return false;
        }

        const params = {
            id,
            returnDate: willNotReturn ? null : dayjs(receivedHorseDate).format("DD/MM/YYYY"),
            actulExportDate: dayjs(exportDateModal).format("DD/MM/YYYY"),
            willNotReturn,
            reasonForNonReturn: willNotReturn ? returnReason.trim() : null,
        };

        setExportDateModal("");
        setReceivedHorseDate(null);
        setReturnReason("");
        setOpenConfirmReceivedHorseDatePopup(false);

        dispatch(FetchConfirmReceivedHorseDatethunk(params));
        return true;
    };

    const handelShowIsChatAction = (item) => {
        return !!(item.isChatAction || item.isDataChatAction);
    };

    const handelClickIsChatAction = (e, item) => {
        e.preventDefault();
        setServiceRequestId(item.id);
        setServiceDefinitionName(item.serviceDefinitionName);
        setReferenceNumber(item.referenceNumber);
        setOpenChatPopup((o) => !o);
        setChatAction(!!item.isChatAction);

        let params = {
            serviceId: item.id,
            type: "Profile",
        };
        dispatch(FetchGetFollowUpDatathunk(params));
    };

    const handelAddFollowUp = (id) => {
        if (chat.trim() !== "") {
            let params = {
                ownerId: localStorage.getItem("currentSubAccountId"),
                serviceId: id,
                comment: chat,
            };
            setChat("");
            setErrorChat(false);
            dispatch(FetchAddFollowUpthunk(params));

            let paramsFollowUpData = {
                serviceId: id,
                type: "Profile",
            };
            setTimeout(() => {
                dispatch(FetchGetFollowUpDatathunk(paramsFollowUpData));
            }, 500);
        } else {
            setErrorChat(true);
            return false;
        }
    };

    const handelPopupConfirmImportDate = (e, item) => {
        e.preventDefault();
        setServiceRequestId(item.id);
        setServiceDefinitionName(item.serviceDefinitionName);
        setReferenceNumber(item.referenceNumber);
        setImportDateD(dayjs(item.importHorseFrozenSemenDto.adminConfirmDate).format("YYYY-MM-DD"));
        setOpenConfirmImportDatePopup((o) => !o);
    };

    const handelPopupConfirmReceivedHorseDate = (e, item) => {
        e.preventDefault();
        setServiceRequestId(item.id);
        setServiceDefinitionName(item.serviceDefinitionName);
        setReferenceNumber(item.referenceNumber);
        setReceivedHorseDateD(dayjs(item.exportHorseDto.exportDateTime).format("YYYY-MM-DD"));
        setOpenConfirmReceivedHorseDatePopup((o) => !o);
    };

    const handleViewFile = (filePath) => {
        window.open(filePath, '_blank');
    };

    return (
        <div className="col-lg-9 col-md-8 col-sm-12 rtl">
            <div className="row rtl mb-main">
                <div className="col-sm-6 col-12">
                    <SearchBox
                        isFullWidth
                        isWithSubmitBTN={true}
                        value={searchServices || ""}
                        onChange={handleSearchChange}
                        onSubmitBtnFunction={handleSearchSubmit}
                        placeholder={translate("web.searchByKeyword", "Search By Keyword")}
                    />
                </div>
            </div>

            <div className="scrolableTable mb-main">
                <table className="table table-striped table-bordered rtl horseResultTable">
                    <thead className="theadHorseSelect">
                        <tr>
                            <th className="text-center">{translate("web.refNo", "Ref.No")}</th>
                            <th className="text-center">{translate("web.serviceType", "Service Type")}</th>
                            <th className="text-center">{translate("web.applicant", "Applicant")}</th>
                            <th className="text-center">{translate("web.horse", "Horse")}</th>
                            <th className="text-center">{translate("web.createdDate", "Created Date")}</th>
                            <th className="text-center">{translate("web.submissionDate", "Submission Date")}</th>
                            <th className="text-center">{translate("web.status", "Status")}</th>
                            <th className="text-center">{translate("web.paymentStatus", "Payment Status")}</th>
                            <th className="text-center">{translate("web.isCancelled", "Is Cancelled")}</th>
                            <th className="text-center">{translate("web.action", "Action")}</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {!servicesRequestsLoading &&
                            currentData?.length > 0 &&
                            currentData.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ fontSize: 13 }}>{item.referenceNumber}</td>
                                    <td style={{ fontSize: 13 }}>{item.serviceDefinitionName}</td>
                                    <td style={{ fontSize: 13 }}>{item.applicant}</td>
                                    <td style={{ fontSize: 13 }}>
                                        {item.horseName}
                                        {item.ownerShipTransfer?.numberOfDoses > 0 &&
                                            ` ${translate("web.numberOfSemenDoses", "Number Of Semen Doses")} (${item.ownerShipTransfer?.numberOfDoses})`}
                                        {item.importHorseFrozenSemenDto?.noDoses > 0 &&
                                            ` ${translate("web.numberOfSemenDoses", "Number Of Semen Doses")} (${item.importHorseFrozenSemenDto?.noDoses})`}
                                    </td>
                                    <td>{item.createdDate && formatDateTimeToString(item.createdDate)}</td>
                                    <td>{item.date && formatDateTimeToString(item.date)}</td>
                                    <td style={{ fontSize: 15 }}>
                                        {item.status}
                                        {item.eventName === "WatingStallionOwnerApproval" &&
                                            ` (${item.coveringCertificates?.ownerNotStallionReg})`}
                                        {item.eventName === "WaitingMareOwnerApproval" && ` (${item?.coveringCertificates?.ownerNotMareReg})`}
                                    </td>
                                    <td>
                                        {item.paymentStatus === "Complete"
                                            ? translate(`web._${item.paymentStatusMethod}`, item.paymentStatusMethod)
                                            : translate(`web.${item.paymentStatus.toLowerCase()}`, item.paymentStatus)}
                                    </td>
                                    <td>{item.isCanceled === true ? translate("web.yes", "Yes") : ""}</td>
                                    <td>
                                        <div className="d-flex flex-wrap justify-content-center gap-2">
                                            {item.isEditAction && (
                                                <>
                                                    <Link to={item.editLink}>
                                                        <i className="fas fa-edit" title={translate("web.edit", "Edit")}></i>
                                                    </Link>
                                                    <Link
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setOpenPopup(true);
                                                            setServiceRequestId(item.id);
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-trash" title={translate("web.delete", "Delete")}></i>
                                                    </Link>
                                                </>
                                            )}
                                            {item.isViewAction && (
                                                <Link to={item.viewLink}>
                                                    <i className="fa-solid fa-eye" title={translate("web.view", "View")}></i>
                                                </Link>
                                            )}
                                            {item.isApproveAction && (
                                                <Link to={item.isApproveHorseAction ? `${item.approveLink}&isApproveHorseAction=true` : item.approveLink}>
                                                    <i className="fa fa-check" title={translate("web.approve", "Approve")}></i>
                                                </Link>
                                            )}
                                            {(item.isNumberOfDosesAction || item.isCompleted) && item.reportUrl && (
                                                <Link to={item.reportUrl} target="_blank">
                                                    <i className="fa fa-download" title={translate(item.reportUrlLabel, item.reportUrlLabel)}></i>
                                                </Link>
                                            )}
                                            {item.isNumberOfDosesForExportAction && (
                                                <Link to={item.exportSemenDosestUrl} target="_blank">
                                                    <i className="fa fa-download" title={translate(item.exportSemenDosesLabel, item.exportSemenDosesLabel)}></i>
                                                </Link>
                                            )}
                                            {item.isConfirmImportDate === false && (
                                                <Link onClick={(e) => handelPopupConfirmImportDate(e, item)}>
                                                    <i className="fa-regular fa-circle-check" title={translate("web.confirmImport", "Confirm Import")}></i>
                                                </Link>
                                            )}
                                            {item.isConfirmImportDate === true && (
                                                <Link to={item.confirmReportUrl} target="_blank">
                                                    <i className="fa fa-download" title={translate("web.downloadSemenDoesCertificate", "Download Semen Does Certificate")}></i>
                                                </Link>
                                            )}
                                            {item.isConfirmReturnHorse === false && (
                                                <Link onClick={(e) => handelPopupConfirmReceivedHorseDate(e, item)}>
                                                    <i className="fa-regular fa-circle-check" title={translate("web.confirmImport", "Confirm Import")}></i>
                                                </Link>
                                            )}
                                            {handelShowIsChatAction(item) && (
                                                <Link onClick={(e) => handelClickIsChatAction(e, item)}>
                                                    <i className="fas fa-comment-dots" title={translate("web.followUp", "Follow Up")}></i>
                                                </Link>
                                            )}

                                            {item.geneticDisorderTesting?.geneticDisorderTestingDetailsDto?.some((detail) => detail.supportFile != null && detail.supportFile !== "") && (
                                                <div className="dropdown d-inline-block">
                                                    <button
                                                        className="btn btn-link p-0 border-0 dropdown-toggle"
                                                        type="button"
                                                        id={`supportFileDropdown-${item.id}`}
                                                        data-bs-toggle="dropdown"
                                                        data-bs-display="static"
                                                        aria-expanded="false"
                                                        style={{ color: '#0d6efd', textDecoration: 'none' }}
                                                    >
                                                        <i className="fa fa-download" title={translate(item.reportUrlLabel, item.reportUrlLabel)}></i>
                                                        <style>
                                                            {`
                                                            #supportFileDropdown-${item.id}::after { display: none; }
                                                            .support-file-menu { 
                                                                min-width: 240px; 
                                                                max-height: 400px; 
                                                                overflow-y: auto; 
                                                                border-radius: 10px; 
                                                                padding: 10px 0; 
                                                                z-index: 9999; 
                                                            }
                                                            .support-file-item { font-size: 13px; padding: 8px 15px; display: flex; align-items: center; gap: 10px; transition: 0.2s; }
                                                            .support-file-item:hover { background-color: #f8f9fa; color: #d6293e !important; }
                                                            .show-right { 
                                                                left: 0 !important; 
                                                                right: auto !important; 
                                                                transform: none !important; 
                                                            }
                                                            `}
                                                        </style>
                                                    </button>
                                                    <ul 
                                                        className={`dropdown-menu shadow border-0 support-file-menu ${currentLanguage === 'ar' ? 'show-right' : 'dropdown-menu-end'}`} 
                                                        aria-labelledby={`supportFileDropdown-${item.id}`}
                                                        style={{ 
                                                            direction: currentLanguage === 'ar' ? 'rtl' : 'ltr', 
                                                            textAlign: currentLanguage === 'ar' ? 'right' : 'left',
                                                            marginTop: '8px'
                                                        }}
                                                    >
                                                        {item.geneticDisorderTesting.geneticDisorderTestingDetailsDto.map((detail, index) => (
                                                            detail.supportFile && (
                                                                <li key={index}>
                                                                    <Link
                                                                        to="#"
                                                                        className="dropdown-item support-file-item"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleViewFile(detail.supportFile.fileUrl);
                                                                        }}
                                                                    >
                                                                        <i className={`${detail.supportFile.fileType === ".pdf" ? "fa-regular fa-file-pdf text-danger" : "fa-regular fa-file-image text-primary"} ${currentLanguage === 'ar' ? 'ms-3' : 'me-3'}`}></i>
                                                                        <span>{detail.horseName || translate("web.horseName", "Horse Name")}</span>
                                                                    </Link>
                                                                </li>
                                                            )
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}

                                        </div>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
                <div className="pagination-buttons rtl mb-4">
                    <NewActionButton
                        classNames="btn-outline-danger w-unset"
                        key={'prev'}
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        text={translate("web.previous", "Previous")}
                    />
                    <NewActionButton
                        classNames="btn-danger w-unset ms-2"
                        key={'pages'}
                        text={`${currentPage} / ${totalPages}`}
                    />
                    <NewActionButton
                        key={'next'}
                        classNames="btn-outline-danger w-unset ms-2"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        text={translate("web.next", "Next")}
                    />
                </div>
            )}

            {/* Delete Service Request pop up */}
            <CustomPopUp
                title={translate("web.confirmMsgDeleteServiceRequest", "are you sure to delete service request?")}
                open={openPopup}
                onClose={closeModal}
                btnText={translate("web.delete", "Delete")}
                onClick={() => {
                    setOpenPopup(false);
                    handelDeleteServiceRequest(serviceRequestId);
                }}
            />

            {/* Chat Service Request pop up */}
            <CustomPopUp
                title={(serviceDefinitionName || "") + " - " + (referenceNumber || "")}
                open={openChatPopup}
                btnText={translate("web.send", "Send")}
                onClick={() => handelAddFollowUp(serviceRequestId)}
                disabled={!chatAction}
                onClose={closeChatModal}
                content={
                    <>
                        <EahsForm title={translate("web.followUpMessages", "FollowUp Messages")}>
                            <FollowUpData data={followUpData} key={'web.followUpData'} />
                        </EahsForm>
                        <div className="mt-5">
                            <NetaqInput
                                label={translate("web.message", "Message")}
                                name={"chat"}
                                type={"textarea"}
                                hideLable={true}
                                maxchars={1150}
                                onChange={(e) => setChat(e.target.value)}
                                value={chat}
                                placeholder={translate("web.addYourMessage", "Add Your Message...")}
                                disabled={!chatAction}
                                textAreaHeight={`${windowHeight * 0.1}px`}
                            />
                            {errorChat && (
                                <p style={{ color: "red" }}>{translate("web.requiredField", "Required Field")}</p>
                            )}
                        </div>
                    </>
                }
            />

            {/* Confirm Import Date pop up */}
            <CustomPopUp
                title={(serviceDefinitionName || "") + " - " + (referenceNumber || "")}
                open={openConfirmImportDatePopup}
                onClose={closeConfirmImportDateModal}
                btnText={translate("web.send", "Send")}
                onClick={() => handelConfirmImportDate(serviceRequestId)}
                content={
                    <div>
                        <NetaqInput
                            htmlTags={
                                importDate ? (
                                    <p className={`me-auto px-3 effectiveDateParagraph ${currentLanguage === 'ar' ? 'text-end' : 'text-start'}`} style={{ textAlign: currentLanguage === 'ar' ? 'right' : 'left' }}>
                                        {dayjs(importDate).format("DD/MM/YYYY")}
                                    </p>
                                ) : (
                                    <p className={`me-auto px-3 effectiveDateParagraph ${currentLanguage === 'ar' ? 'text-end' : 'text-start'}`} style={{ textAlign: currentLanguage === 'ar' ? 'right' : 'left' }}>
                                        DD/MM/YYYY
                                    </p>
                                )
                            }
                            name={"importDate"}
                            type={"normalDateService"}
                            label={translate("web.importDate", "Date Of Import")}
                            onChange={(e) => setImportDate(e.target.value)}
                            value={importDate}
                            required={true}
                            minDate={importDateD}
                            maxDate={dayjs().format("YYYY-MM-DD")}
                        />
                        {errorConfirmImportDate && (
                            <p style={{ color: "red" }}>{translate("web.requiredField", "Required Field")}</p>
                        )}
                    </div>
                }
            />

            {/* Confirm Received Horse Date pop up */}
            <CustomPopUp
                title={(serviceDefinitionName || "") + " - " + (referenceNumber || "")}
                open={openConfirmReceivedHorseDatePopup}
                onClose={closeConfirmReceivedHorseDateModal}
                btnText={translate("web.send", "Send")}
                onClick={() => handelConfirmReceivedHorseDate(serviceRequestId)}
                content={
                    <div className="p-3">
                        <div className={eformInput}>
                            <NetaqInput
                                htmlTags={
                                    exportDateModal ? (
                                        <p className={`me-auto px-3 effectiveDateParagraph ${currentLanguage === 'ar' ? 'text-end' : 'text-start'}`} style={{ textAlign: currentLanguage === 'ar' ? 'right' : 'left' }}>
                                            {dayjs(exportDateModal).format("DD/MM/YYYY")}
                                        </p>
                                    ) : (
                                        <p className={`me-auto px-3 effectiveDateParagraph ${currentLanguage === 'ar' ? 'text-end' : 'text-start'}`} style={{ textAlign: currentLanguage === 'ar' ? 'right' : 'left' }}>
                                            DD/MM/YYYY
                                        </p>
                                    )
                                }
                                name="exportDate"
                                type="normalDateService"
                                label={translate("web.exportDate", "Date Of Export")}
                                onChange={(e) => setExportDateModal(e.target.value)}
                                value={exportDateModal}
                                required={true}
                            />
                        </div>
                        <div className={eformCheckBox}>
                            <NetaqInput
                                type={"checkbox"}
                                name="willNotReturn"
                                label={translate("web.willNotReturn", "Will Not Return")}
                                onChange={(e) => setWillNotReturn(e.target.checked)}
                                checked={willNotReturn}
                            />
                        </div>
                        {willNotReturn ? (
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.reason", "Reason for Non-Return")}
                                    name="returnReason"
                                    type="textarea"
                                    maxchars={1150}
                                    value={returnReason}
                                    onChange={(e) => setReturnReason(e.target.value)}
                                    required={willNotReturn}
                                />
                            </div>
                        ) : (
                            <div className={eformInput}>
                                <NetaqInput
                                    htmlTags={
                                        receivedHorseDate ? (
                                            <p className={`me-auto px-3 effectiveDateParagraph ${currentLanguage === 'ar' ? 'text-end' : 'text-start'}`} style={{ textAlign: currentLanguage === 'ar' ? 'right' : 'left' }}>
                                                {dayjs(receivedHorseDate).format("DD/MM/YYYY")}
                                            </p>
                                        ) : (
                                            <p className={`me-auto px-3 effectiveDateParagraph ${currentLanguage === 'ar' ? 'text-end' : 'text-start'}`} style={{ textAlign: currentLanguage === 'ar' ? 'right' : 'left' }}>
                                                DD/MM/YYYY
                                            </p>
                                        )
                                    }
                                    name="importDate"
                                    type="normalDateService"
                                    label={translate("web.importDate", "Date Of Return")}
                                    onChange={(e) => setReceivedHorseDate(e.target.value)}
                                    value={receivedHorseDate}
                                    required={!willNotReturn}
                                    minDate={receivedHorseDateD}
                                />
                            </div>
                        )}
                        {errorExportDate && (
                            <p style={{ color: "red" }}>{translate("web.requiredField", "Required Field")}</p>
                        )}
                        {errorConfirmReceivedHorseDate && !willNotReturn && (
                            <p style={{ color: "red" }}>{translate("web.requiredField", "Required Field")}</p>
                        )}
                        {errorReason && willNotReturn && (
                            <p style={{ color: "red" }}>{translate("web.requiredField", "Required Field")}</p>
                        )}
                    </div>
                }
            />
        </div>
    );
}
